<p-dialog
  [(visible)]="visible"
  [showHeader]="false"
  [modal]="true"
  [closable]="false"
  [draggable]="false"
  styleClass="dialog-wave-redesign"
  [style]="{ width: '36rem' }"
  (onShow)="onDialogShow()"
  (onHide)="onDialogHide()">

  <!-- Header wave -->
  <div class="dialog-wave-header dialog-wave-header--info">
    <div class="dialog-wave-header-content">
      <div class="dialog-wave-icon-container">
        <i class="pi pi-barcode" aria-hidden="true"></i>
      </div>
      <div class="dialog-wave-header-text">
        <h2>{{ texts.titulo }}</h2>
        <p>{{ produto?.nome }}</p>
        <p *ngIf="produto?.barras" class="barras-subtitle">
          {{ texts.subtitulo }}: {{ produto?.barras }}
        </p>
      </div>
    </div>
    <div class="dialog-wave-decorative-circle circle-1" aria-hidden="true"></div>
    <div class="dialog-wave-decorative-circle circle-2" aria-hidden="true"></div>
    <svg class="dialog-wave-svg" viewBox="0 0 1200 40" preserveAspectRatio="none" aria-hidden="true">
      <path d="M0,20 C150,40 350,0 500,20 C650,40 850,0 1000,20 C1100,32 1150,20 1200,20 L1200,40 L0,40 Z" fill="white"/>
    </svg>
  </div>

  <!-- Conteudo -->
  <div class="etiqueta-dialog-body">

    <!-- Loading -->
    <div *ngIf="loading" class="loading-container">
      <p-progressSpinner [style]="{ width: '50px', height: '50px' }"></p-progressSpinner>
      <span class="loading-text">{{ texts.gerando_pdf }}</span>
    </div>

    <!-- Formulario (estado inicial) -->
    <div *ngIf="!loading && !pdfGerado" class="etiqueta-form">
      <div class="field">
        <label for="itemSelecionado" class="font-semibold">{{ labels.item_selecionado }}</label>
        <input
          pInputText
          id="itemSelecionado"
          [value]="produto?.nome || ''"
          [disabled]="true"
          [style]="{ width: '100%' }">
      </div>

      <div class="field" [class.field-error]="erros.tipoImpressao">
        <label for="tipoImpressao" class="font-semibold">{{ labels.tipo_folha }} *</label>
        <p-dropdown
          id="tipoImpressao"
          [options]="tiposImpressao"
          [(ngModel)]="form.tipoImpressao"
          optionLabel="label"
          [placeholder]="placeholders.selecione_tipo"
          [showClear]="true"
          [ngClass]="{ 'ng-invalid ng-dirty': erros.tipoImpressao }"
          [style]="{ width: '100%' }"
          appendTo="body"
          panelStyleClass="dropdown-panel-above-modal"
          [overlayOptions]="{ baseZIndex: 9999 }">
        </p-dropdown>
      </div>

      <div class="field" [class.field-error]="erros.quantidade">
        <label for="quantidade" class="font-semibold">{{ labels.quantidade }} *</label>
        <input
          pInputText
          type="number"
          id="quantidade"
          [(ngModel)]="form.quantidade"
          min="1"
          max="270"
          [placeholder]="'1 - 270'"
          [ngClass]="{ 'ng-invalid ng-dirty': erros.quantidade }"
          [style]="{ width: '100%' }">
      </div>

      <div *ngIf="isA4" class="field" [class.field-error]="erros.quantidadeImpressa">
        <label for="quantidadeImpressa" class="font-semibold">{{ labels.quantidade_impressa }}</label>
        <input
          pInputText
          type="number"
          id="quantidadeImpressa"
          [(ngModel)]="form.quantidadeImpressa"
          min="0"
          [placeholder]="'0'"
          [ngClass]="{ 'ng-invalid ng-dirty': erros.quantidadeImpressa }"
          [style]="{ width: '100%' }">
      </div>
    </div>

    <!-- Preview como imagem (renderizada via pdfjs) -->
    <div *ngIf="!loading && pdfGerado" class="pdf-preview-container">

      <!-- Loading da renderizacao da imagem -->
      <div *ngIf="loadingPreview" class="preview-loading">
        <p-progressSpinner [style]="{ width: '40px', height: '40px' }"></p-progressSpinner>
        <span class="loading-text">{{ texts.carregando_preview }}</span>
      </div>

      <!-- Imagem renderizada -->
      <div *ngIf="!loadingPreview && pdfImagemPreviewUrl" class="preview-imagem-wrapper">
        <img
          [src]="pdfImagemPreviewUrl"
          alt="Preview etiqueta"
          class="etiqueta-preview-img"
          [title]="texts.clique_para_ampliar"
          (click)="abrirImagemExpandida()">
        <div class="preview-zoom-hint">
          <i class="pi pi-search-plus"></i>
          <span>{{ texts.clique_para_ampliar }}</span>
        </div>
      </div>
    </div>
  </div>

  <!-- Footer -->
  <ng-template pTemplate="footer">
    <div class="dialog-footer">
      <button pButton
        [label]="botoes.cancelar"
        class="p-button-secondary"
        (click)="fechar()">
      </button>

      <!-- Botoes estado formulario -->
      <ng-container *ngIf="!pdfGerado && !loading">
        <button pButton
          [label]="botoes.limpar"
          icon="pi pi-refresh"
          class="p-button-outlined p-button-secondary"
          (click)="limpar()">
        </button>
        <button pButton
          [label]="botoes.gerar"
          icon="pi pi-cog"
          (click)="submit()">
        </button>
      </ng-container>

      <!-- Botoes estado preview -->
      <ng-container *ngIf="pdfGerado && !loading">
        <button pButton
          [label]="botoes.imprimir"
          icon="pi pi-print"
          [disabled]="loadingPreview"
          (click)="imprimir()">
        </button>
        <button pButton
          [label]="botoes.download"
          icon="pi pi-download"
          severity="success"
          [disabled]="loadingPreview"
          (click)="download()">
        </button>
      </ng-container>
    </div>
  </ng-template>
</p-dialog>

<!-- Lightbox: imagem expandida -->
<p-dialog
  [(visible)]="imagemExpandidaVisible"
  [modal]="true"
  [closable]="true"
  [draggable]="false"
  [dismissableMask]="true"
  [header]="texts.titulo_imagem_expandida"
  styleClass="dialog-imagem-expandida"
  [style]="{ width: '800px' }"
  (onHide)="fecharImagemExpandida()">

  <div class="imagem-expandida-container" *ngIf="pdfImagemPreviewUrl">
    <img
      [src]="pdfImagemPreviewUrl"
      alt="Preview etiqueta ampliada"
      class="etiqueta-preview-img-expandida">
  </div>
</p-dialog>
